import React, { useState } from 'react';

const EmploymentInfo = ({ employmentData }) => {

  const formatDate = (date) => {
    const rawDate = date.split('T')[0];
    const dateParts = rawDate.split('-');
    return `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
  }

  return (
    <div>
      <table style={{ marginTop: '20px' }}>
        <tbody>
          <tr>
            <th className="bg center">
              <p>Трудовая деятельность<br />(включая неофициальный), начиная с последнего места работы</p>
            </th>
          </tr>
        </tbody>
      </table>
      {employmentData.map((employment, index) => (
        <table key={index} style={{ marginBottom: '20px', marginTop: '-1px' }}>
          <tbody>
            <tr>
              <td width="25%"><p>Наименование предприятия/компании:</p></td>
              <td width="75%" style={{ position: 'relative' }}>
                <p>{employment.Organization}</p>
              </td>
            </tr>
            <tr>
              <td><p>Профиль деятельности предприятия/компании:</p></td>
              <td><p>{employment.ActivityProfile}</p></td>
            </tr>
            <tr>
              <td><p>Период трудовой деятельности:</p></td>
              <td>
                <p>С {formatDate(employment.EmploymentDate)} по {formatDate(employment.DismissalDate)}</p>
              </td>
            </tr>
            <tr>
              <td><p>Должность:</p></td>
              <td><p>{employment.Position}</p></td>
            </tr>
            <tr>
              <td><p>Функциональные обязанности:</p></td>
              <td><p>{employment.Duties}</p></td>
            </tr>
          </tbody>
        </table>
      ))}
    </div>
  );
};

export default EmploymentInfo;
